import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "space-y-4 sm:space-y-6" }
const _hoisted_2 = { class: "card mb-6" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "flex flex-col sm:flex-row items-center sm:items-start space-y-4 sm:space-y-0 sm:space-x-6" }
const _hoisted_5 = { class: "h-16 w-16 sm:h-20 sm:w-20 rounded-full overflow-hidden bg-[#0275b1] ring-4 ring-[#ffd62e] flex items-center justify-center text-white text-2xl sm:text-3xl font-bold shadow-md transform transition-transform duration-300 hover:scale-105" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-center sm:text-left" }
const _hoisted_9 = { class: "text-xl sm:text-2xl font-bold text-[#0b6623] dark:text-emerald-400" }
const _hoisted_10 = { class: "text-sm sm:text-base text-gray-600 dark:text-gray-300 mt-1" }
const _hoisted_11 = {
  key: 0,
  class: "mt-6 flex flex-col justify-center items-center py-12"
}
const _hoisted_12 = {
  key: 1,
  class: "mt-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6"
}
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = { class: "text-red-700 dark:text-red-300 font-medium" }
const _hoisted_15 = {
  key: 2,
  class: "space-y-4 sm:space-y-6"
}
const _hoisted_16 = { class: "flex items-center gap-2" }
const _hoisted_17 = ["onChange"]
const _hoisted_18 = ["onChange"]
const _hoisted_19 = ["onChange"]
const _hoisted_20 = {
  key: 0,
  class: "flex items-center gap-4 text-sm"
}
const _hoisted_21 = { class: "flex items-center gap-2" }
const _hoisted_22 = { class: "text-gray-600 dark:text-gray-400" }
const _hoisted_23 = { class: "font-medium text-green-600 dark:text-green-400" }
const _hoisted_24 = { class: "flex items-center gap-2" }
const _hoisted_25 = { class: "text-gray-600 dark:text-gray-400" }
const _hoisted_26 = { class: "font-medium text-red-600 dark:text-red-400" }
const _hoisted_27 = { class: "break-all" }
const _hoisted_28 = { class: "break-all" }
const _hoisted_29 = { class: "flex flex-col items-start justify-center space-y-1 text-xs py-0.5 whitespace-nowrap" }
const _hoisted_30 = { class: "flex items-center space-x-1.5" }
const _hoisted_31 = {
  key: 1,
  class: "text-gray-400 dark:text-gray-500 italic"
}
const _hoisted_32 = { class: "flex items-center space-x-1.5" }
const _hoisted_33 = {
  key: 1,
  class: "text-gray-400 dark:text-gray-500 italic"
}
const _hoisted_34 = { class: "flex flex-col items-end justify-center space-y-1 text-xs" }
const _hoisted_35 = { class: "flex items-center space-x-1.5" }
const _hoisted_36 = {
  key: 1,
  class: "text-gray-400 dark:text-gray-500 italic"
}
const _hoisted_37 = { class: "flex items-center space-x-1.5" }
const _hoisted_38 = {
  key: 1,
  class: "text-gray-400 dark:text-gray-500 italic"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "text-gray-600 dark:text-gray-300" }
const _hoisted_41 = {
  key: 0,
  class: "border-l border-purple-200 pl-1.5 text-amber-700 dark:border-purple-800 dark:text-amber-300"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "text-gray-600 dark:text-gray-300" }
const _hoisted_44 = {
  key: 0,
  class: "border-l border-purple-200 pl-1.5 text-amber-700 dark:border-purple-800 dark:text-amber-300"
}
const _hoisted_45 = { class: "flex items-center justify-end gap-2" }
const _hoisted_46 = {
  key: 0,
  class: "inline-flex h-5 w-5 cursor-help items-center justify-center rounded-full bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200",
  title: "This account is linked to a former employee archive record."
}
const _hoisted_47 = { class: "flex items-center" }
const _hoisted_48 = { class: "h-10 w-10 rounded-full overflow-hidden bg-gray-200 dark:bg-gray-700 flex items-center justify-center" }
const _hoisted_49 = ["src", "alt"]
const _hoisted_50 = {
  key: 1,
  class: "text-gray-500 text-sm"
}
const _hoisted_51 = { class: "flex items-center justify-center gap-2" }
const _hoisted_52 = ["title"]
const _hoisted_53 = { class: "flex justify-center items-center space-x-1 sm:space-x-1.5" }
const _hoisted_54 = ["onClick", "title"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick", "title"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "flex flex-wrap justify-end gap-1.5 pt-2 border-t border-gray-100 dark:border-gray-700/60" }
const _hoisted_61 = ["onClick", "title"]
const _hoisted_62 = ["onClick"]
const _hoisted_63 = ["onClick", "title"]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onClick"]

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useTitle } from '@/composables/ui/useTitle'
import { useUser } from '@/composables/auth/useUser'
import { useEmployees } from '@/composables/employee/useEmployees'
import { useEmployeeStore } from '@/stores/employee'
import { useThemeStore } from '@/stores/theme'
import { employeeService } from '@/services/user'
import { useToastService } from '@/services/toast'
import type { employee } from '@/types/employee'
import type { ApplicationDetail } from '@/types/application'
import { applicationService } from '@/services/applicationService'
import RegisterEmployeeModal from '@/components/modals/RegisterEmployee.vue'
import ViewStaffProfileModal from '@/components/modals/ViewStaffProfile.vue'
import EditStaffProfileModal from '@/components/modals/EditStaffProfile.vue'
import ViewStaffDocumentsModal from '@/components/modals/ViewStaffDocuments.vue'
import UploadStaffDocumentsModal from '@/components/modals/UploadStaffDocuments.vue'
import DeleteEmployeeModal from '@/components/modals/DeleteEmployee.vue'
import ViewApplicationDetails from '@/components/modals/ViewApplicationDetails.vue'
import DataTable from '@/components/common/DataTable.vue'
import { 
  AlertCircle,
  Archive,
  Plus,
  Lock,
  LockOpen,
  Edit3,
  Trash2,
  Users,
  FileText,
  FileCheck,
  FolderLock,
  Eye,
} from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeView',
  setup(__props) {

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Jeducare')
useTitle(`Staff - ${appTitle.value}`)

const route = useRoute()
const initialDocumentsCategory = ref<string>('all')

const { userInitials, userName, userEmail, userImage } = useUser()

// Toast service for notifications
const toast = useToastService()

// Theme store for dark mode detection
const themeStore = useThemeStore()
const isDarkMode = computed(() => themeStore.isDarkMode)

// employee management
const {
  employees,
  isLoading,
  error,
  fetchEmployees,
  setSearch,
  setStatusFilter,
  setWorkStateFilter,
  setServicePopulationFilter,
  setPagination,
  activeEmployees,
  inactiveEmployees,
  statusFilter: storedStatusFilter,
  workStateFilter: storedWorkStateFilter,
  servicePopulationFilter: storedServicePopulationFilter
} = useEmployees()

// Modal state
const isRegisterModalVisible = ref(false)
const isDeleteModalVisible = ref(false)
const isViewProfileModalVisible = ref(false)
const isEditProfileModalVisible = ref(false)
const isDocumentsModalVisible = ref(false)
const isUploadModalVisible = ref(false)

// Application Details Modal (for staff approved through application system)
const isApplicationDetailsModalVisible = ref(false)
const selectedApplicationDetails = ref<ApplicationDetail | null>(null)
const isLoadingApplicationDetails = ref(false)

const selectedEmployeeForProfile = ref<employee | null>(null)
const selectedEmployeeForEdit = ref<employee | null>(null)
const selectedEmployeeForDocuments = ref<employee | null>(null)
const selectedEmployeeForUpload = ref<employee | null>(null)
const selectedEmployeeForDelete = ref<employee | null>(null)

const staffDocumentsModalRef = ref<any>(null)

// Local filter state - initialize from stored values
const statusFilter = ref(storedStatusFilter.value)
const workStateFilter = ref(storedWorkStateFilter.value || '')
const servicePopulationFilter = ref(storedServicePopulationFilter.value || '')

// Table configuration
const tableColumns = [
  { key: 'profile', label: 'Profile', sortable: false, width: '70px' },
  { key: 'first_name', label: 'First Name', sortable: true },
  { key: 'last_name', label: 'Last Name', sortable: true },
  { key: 'email', label: 'Email', sortable: true },
  { key: 'indicators', label: 'State & Group', sortable: false, width: '150px' },
  { key: 'documents', label: 'Documents', sortable: false, align: 'center' as const, width: '120px' },
  { key: 'status', label: 'Status', sortable: true, align: 'center' as const, width: '90px' }
]

const sortableColumns = [
  { key: 'first_name', label: 'First Name' },
  { key: 'last_name', label: 'Last Name' },
  { key: 'email', label: 'Email' },
  { key: 'status', label: 'Status' }
]

const mobileColumns = [
  { key: 'first_name', label: 'First Name' },
  { key: 'last_name', label: 'Last Name' },
  { key: 'email', label: 'Email' },
  { key: 'indicators', label: 'State & Group' },
  { key: 'documents', label: 'Documents' },
  { key: 'status', label: 'Status' }
]

// DataTable event handlers
const handleSearch = (query: string) => {
  setSearch(query)
}

const employeeStore = useEmployeeStore()

const handleSort = (sort: { field: string; direction: 'asc' | 'desc' }) => {
  employeeStore.setFilters({ sortBy: sort.field, sortDirection: sort.direction })
}

const handleFilter = (filters: Record<string, any>) => {
  if (filters.status !== undefined) {
    statusFilter.value = filters.status
    setStatusFilter(filters.status as 'Active' | 'Inactive' | '')
  }
  if (filters.workState !== undefined) {
    workStateFilter.value = filters.workState
    setWorkStateFilter(filters.workState)
  }
  if (filters.servicePopulation !== undefined) {
    servicePopulationFilter.value = filters.servicePopulation
    setServicePopulationFilter(filters.servicePopulation)
  }
}

const handlePageChange = (page: number) => {
  setPagination({ page })
}

const handleItemsPerPageChange = (itemsPerPage: number) => {
  setPagination({ itemsPerPage })
}

// Helper functions
const handleImageError = (event: Event) => {
  const target = event.target as HTMLImageElement
  if (target) {
    target.style.display = 'none'
  }
}

// Modal handlers
const handleRegistrationSuccess = () => {
  fetchEmployees()
}

const handleDeleteSuccess = () => {
  setSearch('')
  fetchEmployees()
}

// Staff Action Handlers
const registerNewUser = () => {
  isRegisterModalVisible.value = true
}

const toggleUserStatus = async (user: any) => {
  try {
    const newStatus = user.status === 'Active' ? 0 : 1
    const action = newStatus === 1 ? 'activated' : 'deactivated'

    await employeeService.updateUserStatus(user.user_details_id, newStatus)

    user.status = newStatus === 1 ? 'Active' : 'Inactive'
    toast.success(`${user.first_name} ${user.last_name} has been ${action}.`)
  } catch (error: any) {
    console.error('Error toggling user status:', error)
    toast.error('Failed to update user status. Please try again.')
  }
}

// View Profile
const openViewProfile = (user: any) => {
  selectedEmployeeForProfile.value = user
  isViewProfileModalVisible.value = true
}

const handleViewProfileClose = () => {
  isViewProfileModalVisible.value = false
}

// Edit Profile
const openEditProfile = (user: any) => {
  selectedEmployeeForEdit.value = user
  isEditProfileModalVisible.value = true
}

const handleProfileOpenEdit = (user: any) => {
  isViewProfileModalVisible.value = false
  openEditProfile(user)
}

const handleProfileEditSuccess = (updatedEmp: employee) => {
  fetchEmployees()
  if (selectedEmployeeForProfile.value && selectedEmployeeForProfile.value.user_details_id === updatedEmp.user_details_id) {
    selectedEmployeeForProfile.value = { ...selectedEmployeeForProfile.value, ...updatedEmp }
  }
}

// Manage Documents
const openStaffDocuments = (user: any, category = 'all') => {
  selectedEmployeeForDocuments.value = user
  initialDocumentsCategory.value = category
  isDocumentsModalVisible.value = true
}

const handleDocumentsModalClose = () => {
  isDocumentsModalVisible.value = false
}

const handleProfileOpenDocuments = (user: any) => {
  isViewProfileModalVisible.value = false
  openStaffDocuments(user)
}

const handleDocumentsUpdated = (count: number) => {
  if (selectedEmployeeForDocuments.value) {
    selectedEmployeeForDocuments.value.total_documents = count
  }
  if (selectedEmployeeForProfile.value) {
    selectedEmployeeForProfile.value.total_documents = count
  }
  // Also update in the table
  const found = employees.value.find(e => e.user_details_id === selectedEmployeeForDocuments.value?.user_details_id)
  if (found) {
    found.total_documents = count
  }
}

// Upload Documents
const openUploadDocuments = (user: any) => {
  selectedEmployeeForUpload.value = user
  isUploadModalVisible.value = true
}

const handleProfileOpenUpload = (user: any) => {
  isViewProfileModalVisible.value = false
  openUploadDocuments(user)
}

const handleUploadSuccess = () => {
  fetchEmployees()
  if (isDocumentsModalVisible.value && staffDocumentsModalRef.value) {
    staffDocumentsModalRef.value.fetchDocuments?.()
  }
}

const deleteUser = (user: employee) => {
  selectedEmployeeForDelete.value = user
  isDeleteModalVisible.value = true
}

// Application Details Modal Handlers
const openApplicationDetails = async (emp: employee) => {
  if (!emp.application_id) {
    toast.error('This staff member does not have an associated application record.')
    return
  }
  isLoadingApplicationDetails.value = true
  selectedApplicationDetails.value = null
  isApplicationDetailsModalVisible.value = true
  try {
    const response = await applicationService.getApplication(emp.application_id)
    if (response.success && response.data) {
      selectedApplicationDetails.value = response.data
    } else {
      toast.error('Failed to load application details.')
      isApplicationDetailsModalVisible.value = false
    }
  } catch (err: any) {
    const msg = err.response?.data?.message || err.message || 'Error loading application details.'
    toast.error(msg)
    isApplicationDetailsModalVisible.value = false
  } finally {
    isLoadingApplicationDetails.value = false
  }
}

const handleCloseApplicationDetails = () => {
  isApplicationDetailsModalVisible.value = false
  selectedApplicationDetails.value = null
}

const handleApplicationDocumentsUpdated = () => {
  fetchEmployees()
}

const checkRouteForOpenDocuments = () => {
  if (route.query.open_docs === 'true' && route.query.employee_id) {
    const empId = Number(route.query.employee_id)
    const emp = employees.value.find(e => e.user_details_id === empId || e.user_id === empId)
    if (emp) {
      const initialCat = (route.query.initial_filter as string) || (route.query.filter as string) || 'all'
      openStaffDocuments(emp, initialCat)
    }
  }
}

const checkRouteForOpenApplication = () => {
  if (
    (route.query.view_application === 'true' || route.query.application_id) &&
    (route.query.employee_id || route.query.application_id)
  ) {
    const empId = Number(route.query.employee_id)
    const appId = Number(route.query.application_id)
    const emp = employees.value.find(
      e => (empId && (e.user_details_id === empId || e.user_id === empId)) || (appId && e.application_id === appId)
    )
    if (emp && emp.application_id) {
      openApplicationDetails(emp)
    }
  }
}

watch(
  () => [route.query.open_docs, route.query.view_application, route.query.application_id, route.query.employee_id, employees.value.length],
  () => {
    checkRouteForOpenDocuments()
    checkRouteForOpenApplication()
  }
)

// Load employees on component mount
onMounted(async () => {
  await fetchEmployees()
  checkRouteForOpenDocuments()
  checkRouteForOpenApplication()
})

return (_ctx: any,_cache: any) => {
  const _component_vue_loaders = _resolveComponent("vue-loaders")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_unref(userImage))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(userImage),
                    alt: _unref(userName),
                    class: "w-full h-full object-cover"
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(userInitials)), 1))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h1", _hoisted_9, " Welcome, " + _toDisplayString(_unref(userName)) + "! ", 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(userEmail)), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(RegisterEmployeeModal, {
      "is-visible": isRegisterModalVisible.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isRegisterModalVisible.value = false)),
      onSuccess: handleRegistrationSuccess
    }, null, 8, ["is-visible"]),
    _createVNode(ViewStaffProfileModal, {
      "is-visible": isViewProfileModalVisible.value,
      employee: selectedEmployeeForProfile.value,
      onClose: handleViewProfileClose,
      onEdit: handleProfileOpenEdit,
      onManageDocuments: handleProfileOpenDocuments,
      onUploadDocuments: handleProfileOpenUpload,
      onViewApplication: openApplicationDetails
    }, null, 8, ["is-visible", "employee"]),
    _createVNode(EditStaffProfileModal, {
      "is-visible": isEditProfileModalVisible.value,
      employee: selectedEmployeeForEdit.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (isEditProfileModalVisible.value = false)),
      onSuccess: handleProfileEditSuccess
    }, null, 8, ["is-visible", "employee"]),
    _createVNode(ViewStaffDocumentsModal, {
      ref_key: "staffDocumentsModalRef",
      ref: staffDocumentsModalRef,
      "is-visible": isDocumentsModalVisible.value,
      employee: selectedEmployeeForDocuments.value,
      "initial-category": initialDocumentsCategory.value,
      onClose: handleDocumentsModalClose,
      onUpload: openUploadDocuments,
      onUpdated: handleDocumentsUpdated
    }, null, 8, ["is-visible", "employee", "initial-category"]),
    _createVNode(UploadStaffDocumentsModal, {
      "is-visible": isUploadModalVisible.value,
      employee: selectedEmployeeForUpload.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (isUploadModalVisible.value = false)),
      onSuccess: handleUploadSuccess
    }, null, 8, ["is-visible", "employee"]),
    _createVNode(DeleteEmployeeModal, {
      "is-visible": isDeleteModalVisible.value,
      employee: selectedEmployeeForDelete.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (isDeleteModalVisible.value = false)),
      onSuccess: handleDeleteSuccess
    }, null, 8, ["is-visible", "employee"]),
    _createVNode(ViewApplicationDetails, {
      "is-visible": isApplicationDetailsModalVisible.value,
      application: selectedApplicationDetails.value,
      onClose: handleCloseApplicationDetails,
      onDocumentsUpdated: handleApplicationDocumentsUpdated
    }, null, 8, ["is-visible", "application"]),
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_vue_loaders, {
            name: "line-scale",
            color: isDarkMode.value ? '#34d399' : '#0b6623',
            scale: "1.2",
            class: "mb-4"
          }, null, 8, ["color"]),
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-gray-900 dark:text-white" }, "Loading staff...", -1))
        ]))
      : (_unref(error))
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(AlertCircle), { class: "h-5 w-5 text-red-500 mr-2" }),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(error)), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(fetchEmployees) && _unref(fetchEmployees)(...args))),
              class: "mt-2 text-sm text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-200 underline"
            }, " Try again ")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(DataTable, {
              data: _unref(employees),
              columns: tableColumns,
              loading: _unref(isLoading),
              "sortable-columns": sortableColumns,
              "mobile-columns": mobileColumns,
              "item-key": "user_details_id",
              "item-label": "staff",
              "search-placeholder": "Search by name, email...",
              "summary-icon": _unref(Users),
              "show-search": true,
              "show-filters": true,
              "show-pagination": true,
              "show-summary": true,
              "disable-client-filter": true,
              "items-per-page": 10,
              "items-per-page-options": [5, 10, 25, 50],
              "table-id": "staff-table",
              onSearch: handleSearch,
              onSort: handleSort,
              onFilter: handleFilter,
              onPageChange: handlePageChange,
              onItemsPerPageChange: handleItemsPerPageChange
            }, {
              actions: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_router_link, {
                    to: "/applications",
                    class: "px-3 py-1.5 text-xs font-semibold rounded-lg border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 flex items-center gap-1.5 transition shadow-sm",
                    title: "View approved applications pending staff account creation"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FileText), { class: "h-3.5 w-3.5 text-secondary dark:text-secondary-dark-text" }),
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "hidden sm:inline" }, "Approved Applicants", -1))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("button", {
                    onClick: registerNewUser,
                    class: "btn btn-primary btn-sm flex items-center gap-2"
                  }, [
                    _createVNode(_unref(Plus), { class: "h-4 w-4" }),
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "hidden sm:inline" }, "Register Staff", -1))
                  ])
                ])
              ]),
              filters: _withCtx(({ updateFilter }) => [
                _createElementVNode("div", null, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Status ", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((statusFilter).value = $event)),
                    onChange: ($event: any) => (updateFilter('status', statusFilter.value)),
                    class: "block w-full px-3 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200 shadow-sm hover:shadow-md"
                  }, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("option", { value: "" }, "All Status", -1),
                    _createElementVNode("option", { value: "Active" }, "Active", -1),
                    _createElementVNode("option", { value: "Inactive" }, "Inactive", -1)
                  ]))], 40, _hoisted_17), [
                    [_vModelSelect, statusFilter.value]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Work State ", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((workStateFilter).value = $event)),
                    onChange: ($event: any) => (updateFilter('workState', workStateFilter.value)),
                    class: "block w-full px-3 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200 shadow-sm hover:shadow-md"
                  }, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("option", { value: "" }, "All States", -1),
                    _createElementVNode("option", { value: "Maryland" }, "Maryland", -1),
                    _createElementVNode("option", { value: "DC" }, "DC", -1),
                    _createElementVNode("option", { value: "Both" }, "Both (MD & DC)", -1)
                  ]))], 40, _hoisted_18), [
                    [_vModelSelect, workStateFilter.value]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Client Group ", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((servicePopulationFilter).value = $event)),
                    onChange: ($event: any) => (updateFilter('servicePopulation', servicePopulationFilter.value)),
                    class: "block w-full px-3 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200 shadow-sm hover:shadow-md"
                  }, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("option", { value: "" }, "All Client Groups", -1),
                    _createElementVNode("option", { value: "Adults" }, "Adults", -1),
                    _createElementVNode("option", { value: "Kids" }, "Kids", -1),
                    _createElementVNode("option", { value: "Both" }, "Both (Adults & Kids)", -1)
                  ]))], 40, _hoisted_19), [
                    [_vModelSelect, servicePopulationFilter.value]
                  ])
                ])
              ]),
              summary: _withCtx(({ totalItems }) => [
                (totalItems > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "w-2 h-2 bg-green-500 rounded-full" }, null, -1)),
                        _createElementVNode("span", _hoisted_22, [
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(activeEmployees)), 1),
                          _cache[17] || (_cache[17] = _createTextVNode(" active ", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "w-2 h-2 bg-red-500 rounded-full" }, null, -1)),
                        _createElementVNode("span", _hoisted_25, [
                          _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(inactiveEmployees)), 1),
                          _cache[19] || (_cache[19] = _createTextVNode(" inactive ", -1))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              "cell-email": _withCtx(({ value }) => [
                _createElementVNode("span", _hoisted_27, _toDisplayString(value), 1)
              ]),
              "mobile-email": _withCtx(({ value }) => [
                _createElementVNode("span", _hoisted_28, _toDisplayString(value), 1)
              ]),
              "cell-indicators": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-gray-400 dark:text-gray-500 font-medium" }, "State:", -1)),
                    (item.work_state)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["font-semibold", [
                item.work_state === 'Maryland'
                  ? 'text-blue-600 dark:text-blue-400'
                  : item.work_state === 'DC'
                  ? 'text-emerald-600 dark:text-emerald-400'
                  : 'text-indigo-600 dark:text-indigo-400'
              ]])
                        }, _toDisplayString(item.work_state === 'Both' ? 'MD & DC' : item.work_state), 3))
                      : (_openBlock(), _createElementBlock("span", _hoisted_31, "None"))
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-gray-400 dark:text-gray-500 font-medium" }, "Group:", -1)),
                    (item.service_population)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["font-semibold", [
                item.service_population === 'Adults'
                  ? 'text-amber-700 dark:text-amber-400'
                  : item.service_population === 'Kids'
                  ? 'text-pink-600 dark:text-pink-400'
                  : 'text-teal-600 dark:text-teal-400'
              ]])
                        }, _toDisplayString(item.service_population === 'Both' ? 'Adults & Kids' : item.service_population), 3))
                      : (_openBlock(), _createElementBlock("span", _hoisted_33, "None"))
                  ])
                ])
              ]),
              "mobile-indicators": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-gray-400 dark:text-gray-500 font-medium" }, "State:", -1)),
                    (item.work_state)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["font-semibold", [
                item.work_state === 'Maryland'
                  ? 'text-blue-600 dark:text-blue-400'
                  : item.work_state === 'DC'
                  ? 'text-emerald-600 dark:text-emerald-400'
                  : 'text-indigo-600 dark:text-indigo-400'
              ]])
                        }, _toDisplayString(item.work_state === 'Both' ? 'MD & DC' : item.work_state), 3))
                      : (_openBlock(), _createElementBlock("span", _hoisted_36, "None"))
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-gray-400 dark:text-gray-500 font-medium" }, "Group:", -1)),
                    (item.service_population)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["font-semibold", [
                item.service_population === 'Adults'
                  ? 'text-amber-700 dark:text-amber-400'
                  : item.service_population === 'Kids'
                  ? 'text-pink-600 dark:text-pink-400'
                  : 'text-teal-600 dark:text-teal-400'
              ]])
                        }, _toDisplayString(item.service_population === 'Both' ? 'Adults & Kids' : item.service_population), 3))
                      : (_openBlock(), _createElementBlock("span", _hoisted_38, "None"))
                  ])
                ])
              ]),
              "cell-documents": _withCtx(({ item }) => [
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (openStaffDocuments(item)),
                  class: _normalizeClass(["inline-flex min-w-[132px] items-center justify-center gap-2 rounded-lg border border-purple-200 bg-white px-3 py-1.5 text-xs font-semibold shadow-xs transition hover:bg-purple-50 dark:border-purple-800 dark:bg-gray-800 dark:hover:bg-purple-950/30", [
            (item.total_documents || 0) > 0
              ? 'bg-purple-50 text-purple-700 hover:bg-purple-100 border-purple-200 dark:bg-purple-950/40 dark:text-purple-300 dark:border-purple-800'
              : 'bg-gray-50 text-gray-500 hover:bg-gray-100 border-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700'
          ]]),
                  title: "Click to view/manage documents"
                }, [
                  _createElementVNode("span", _hoisted_40, _toDisplayString(item.total_documents || 0) + " current", 1),
                  (item.is_former_employee)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(item.former_employee?.total_files || 0) + " archived ", 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_39)
              ]),
              "mobile-documents": _withCtx(({ item }) => [
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (openStaffDocuments(item)),
                  class: "inline-flex min-w-[122px] items-center justify-center gap-2 rounded-lg border border-purple-200 bg-white px-2.5 py-1.5 text-xs font-semibold shadow-xs dark:border-purple-800 dark:bg-gray-800"
                }, [
                  _createElementVNode("span", _hoisted_43, _toDisplayString(item.total_documents || 0) + " current", 1),
                  (item.is_former_employee)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(item.former_employee?.total_files || 0) + " archived ", 1))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_42)
              ]),
              "cell-middle_name": _withCtx(({ value }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(value ? '' : 'text-gray-400 dark:text-gray-500 italic')
                }, _toDisplayString(value || 'Not stated'), 3)
              ]),
              "mobile-middle_name": _withCtx(({ value }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(value ? '' : 'text-gray-400 dark:text-gray-500 italic')
                }, _toDisplayString(value || 'Not stated'), 3)
              ]),
              "mobile-status": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("span", {
                    class: _normalizeClass([
              'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
              item.status === 'Active'
                ? 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100'
                : 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100'
            ])
                  }, _toDisplayString(item.status), 3),
                  (item.is_former_employee)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                        _createVNode(_unref(Archive), { class: "h-3.5 w-3.5" })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              "cell-profile": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    (item.user_image)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: item.user_image,
                          alt: `${item.first_name} ${item.last_name}`,
                          class: "h-full w-full object-cover",
                          onError: handleImageError
                        }, null, 40, _hoisted_49))
                      : (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(item.first_name?.charAt(0) || '') + _toDisplayString(item.last_name?.charAt(0) || ''), 1))
                  ])
                ])
              ]),
              "cell-status": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("span", {
                    class: _normalizeClass([
              'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
              item.status === 'Active'
                ? 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100'
                : 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100'
            ])
                  }, _toDisplayString(item.status), 3),
                  (item.is_former_employee)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "inline-flex h-5 w-5 cursor-help items-center justify-center rounded-full bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200",
                        title: `Former employee record linked${item.former_employee?.date_separated ? `; separated ${item.former_employee.date_separated}` : ''}${item.former_employee?.reason_for_leaving ? `; ${item.former_employee.reason_for_leaving}` : ''}.`
                      }, [
                        _createVNode(_unref(Archive), { class: "h-3.5 w-3.5" })
                      ], 8, _hoisted_52))
                    : _createCommentVNode("", true)
                ])
              ]),
              "row-actions": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("button", {
                    class: _normalizeClass([
              'p-1.5 rounded-lg transition duration-200 transform',
              item.status === 'Active'
                ? 'text-secondary dark:text-secondary-dark dark:hover:text-gray-500 hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800'
                : 'text-primary dark:text-primary-dark-text hover:text-gray-900 dark:hover:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800'
            ]),
                    onClick: ($event: any) => (toggleUserStatus(item)),
                    title: item.status === 'Active' ? 'Deactivate User' : 'Activate User'
                  }, [
                    (item.status === 'Active')
                      ? (_openBlock(), _createBlock(_unref(LockOpen), {
                          key: 0,
                          class: "h-4 w-4"
                        }))
                      : (_openBlock(), _createBlock(_unref(Lock), {
                          key: 1,
                          class: "h-4 w-4"
                        }))
                  ], 10, _hoisted_54),
                  _createElementVNode("button", {
                    class: "p-1.5 rounded-lg text-sky-600 hover:text-sky-800 hover:bg-sky-50 dark:text-sky-400 dark:hover:text-sky-200 dark:hover:bg-sky-950/30 transition",
                    onClick: ($event: any) => (openViewProfile(item)),
                    title: "View Full Staff Profile"
                  }, [
                    _createVNode(_unref(Eye), { class: "h-4 w-4" })
                  ], 8, _hoisted_55),
                  (item.has_application && item.application_id)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "p-1.5 rounded-lg text-emerald-600 hover:text-emerald-800 hover:bg-emerald-50 dark:text-emerald-400 dark:hover:text-emerald-200 dark:hover:bg-emerald-950/30 transition relative",
                        onClick: ($event: any) => (openApplicationDetails(item)),
                        title: `Approved via Application System (App #${item.application_id}) - View Full Application Details`
                      }, [
                        _createVNode(_unref(FileCheck), { class: "h-4 w-4" })
                      ], 8, _hoisted_56))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "p-1.5 rounded-lg text-purple-600 hover:text-purple-800 hover:bg-purple-50 dark:text-purple-400 dark:hover:text-purple-200 dark:hover:bg-purple-950/30 transition",
                    onClick: ($event: any) => (openStaffDocuments(item)),
                    title: "Manage Credentials & Documents"
                  }, [
                    _createVNode(_unref(FolderLock), { class: "h-4 w-4" })
                  ], 8, _hoisted_57),
                  _createElementVNode("button", {
                    class: "p-1.5 rounded-lg text-blue-500 hover:text-blue-700 hover:bg-blue-50 dark:hover:bg-blue-950/30 transition",
                    onClick: ($event: any) => (openEditProfile(item)),
                    title: "Edit Staff Profile"
                  }, [
                    _createVNode(_unref(Edit3), { class: "h-4 w-4" })
                  ], 8, _hoisted_58),
                  _createElementVNode("button", {
                    class: "p-1.5 rounded-lg text-red-500 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-950/30 transition",
                    onClick: ($event: any) => (deleteUser(item)),
                    title: "Delete Staff"
                  }, [
                    _createVNode(_unref(Trash2), { class: "h-4 w-4" })
                  ], 8, _hoisted_59)
                ])
              ]),
              "mobile-actions": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("button", {
                    class: _normalizeClass([
              'transition duration-200 transform flex items-center gap-1 px-2 py-1 rounded text-xs',
              item.status === 'Active'
                ? 'text-secondary dark:text-secondary-dark hover:bg-gray-100 dark:hover:bg-gray-700'
                : 'text-primary dark:text-primary-dark hover:bg-gray-100 dark:hover:bg-gray-700'
            ]),
                    onClick: ($event: any) => (toggleUserStatus(item)),
                    title: item.status === 'Active' ? 'Deactivate User' : 'Activate User'
                  }, [
                    (item.status === 'Active')
                      ? (_openBlock(), _createBlock(_unref(LockOpen), {
                          key: 0,
                          class: "h-3.5 w-3.5"
                        }))
                      : (_openBlock(), _createBlock(_unref(Lock), {
                          key: 1,
                          class: "h-3.5 w-3.5"
                        })),
                    _createElementVNode("span", null, _toDisplayString(item.status === 'Active' ? 'Deactivate' : 'Activate'), 1)
                  ], 10, _hoisted_61),
                  _createElementVNode("button", {
                    class: "text-sky-600 hover:text-sky-800 dark:text-sky-400 dark:hover:text-sky-200 transition flex items-center gap-1 px-2 py-1 rounded text-xs hover:bg-sky-50 dark:hover:bg-sky-950/30",
                    onClick: ($event: any) => (openViewProfile(item)),
                    title: "View Profile"
                  }, [
                    _createVNode(_unref(Eye), { class: "h-3.5 w-3.5" }),
                    _cache[25] || (_cache[25] = _createElementVNode("span", null, "Profile", -1))
                  ], 8, _hoisted_62),
                  (item.has_application && item.application_id)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "text-emerald-600 hover:text-emerald-800 dark:text-emerald-400 dark:hover:text-emerald-200 transition flex items-center gap-1 px-2 py-1 rounded text-xs hover:bg-emerald-50 dark:hover:bg-emerald-950/30",
                        onClick: ($event: any) => (openApplicationDetails(item)),
                        title: `Approved via Application System (App #${item.application_id}) - View Details`
                      }, [
                        _createVNode(_unref(FileCheck), { class: "h-3.5 w-3.5" }),
                        _cache[26] || (_cache[26] = _createElementVNode("span", null, "App", -1))
                      ], 8, _hoisted_63))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "text-purple-600 hover:text-purple-800 dark:text-purple-400 dark:hover:text-purple-200 transition flex items-center gap-1 px-2 py-1 rounded text-xs hover:bg-purple-50 dark:hover:bg-purple-950/30",
                    onClick: ($event: any) => (openStaffDocuments(item)),
                    title: "Documents"
                  }, [
                    _createVNode(_unref(FolderLock), { class: "h-3.5 w-3.5" }),
                    _cache[27] || (_cache[27] = _createElementVNode("span", null, "Docs", -1))
                  ], 8, _hoisted_64),
                  _createElementVNode("button", {
                    class: "text-blue-500 hover:text-blue-700 transition flex items-center gap-1 px-2 py-1 rounded text-xs hover:bg-blue-50 dark:hover:bg-blue-950/30",
                    onClick: ($event: any) => (openEditProfile(item)),
                    title: "Edit Staff"
                  }, [
                    _createVNode(_unref(Edit3), { class: "h-3.5 w-3.5" }),
                    _cache[28] || (_cache[28] = _createElementVNode("span", null, "Edit", -1))
                  ], 8, _hoisted_65),
                  _createElementVNode("button", {
                    class: "text-red-500 hover:text-red-700 transition flex items-center gap-1 px-2 py-1 rounded text-xs hover:bg-red-50 dark:hover:bg-red-950/30",
                    onClick: ($event: any) => (deleteUser(item)),
                    title: "Delete Staff"
                  }, [
                    _createVNode(_unref(Trash2), { class: "h-3.5 w-3.5" }),
                    _cache[29] || (_cache[29] = _createElementVNode("span", null, "Delete", -1))
                  ], 8, _hoisted_66)
                ])
              ]),
              "empty-actions": _withCtx(() => [
                _createElementVNode("button", {
                  onClick: registerNewUser,
                  class: "btn btn-primary btn-md"
                }, "Register Staff")
              ]),
              _: 1
            }, 8, ["data", "loading", "summary-icon"])
          ]))
  ], 64))
}
}

})